declare const window: Window & { pcDataLayer: Record<string, unknown>[] };

interface PageViewUpdate {
  customerId: string;
  leaseId: string;
  merchantName: string;
  storeId: string;
  parentStoreId: number;
  view: string;
}

interface ButtonClick {
  customerId: string;
  leaseId: string;
  merchantName: string;
  storeId: string;
  parentStoreId: number;
  view: string;
  label: string;
}

interface ApplicationResult extends Pick<PageViewUpdate, 'customerId' | 'leaseId'> {
  approvalStatus: string;
  leaseApprovalAmount: number;
}

interface CartSuccess {
  cashPrice: number;
  cartTotalQuantity: number;
  cartTotalItems: number;
  cartTotal: number;
  deliveryCost: number;
}

const defaultData = {
  event: 'eventTracker',
  eventValue: 0,
  eventNonInteraction: 0,
  hitType: 'event',
};

export const { pcDataLayer } = window;

export const gtmButtonClick = ({ view, customerId, leaseId, merchantName, storeId, parentStoreId, label }: ButtonClick) => {
  window.pcDataLayer.push({
    ...defaultData,
    eventAction: 'Button Click',
    eventLabel: label,

    title: view,
    page: `/${view}`,
    location: `${window.location.href}/${view}`,
    localizationLanguage: navigator.language,
    localizationUsed: 0,

    customerId,
    leaseId,

    merchantName,
    storeId,
    parentStoreId,

    flowName: 'connect',
    flowType: 'connect',
    dataSet: 'connect',

    inStoreFlag: 0,
    textToApplyEnabled: 0,
    bankLookupEnabled: 0,
    localizationEnabled: 0,
    paymentEstEnabled: 0,
    rldEnabled: 0,
    storeLocatorEnabled: 0,
  });
};
export const gtmPageView = ({ view, customerId, leaseId, merchantName, storeId, parentStoreId }: PageViewUpdate) => {
  window.pcDataLayer.push({
    event: 'virtualPageview',
    title: view,
    page: `/${view}`,
    location: `${window.location.href}/${view}`,
    hitType: 'pageview',
    localizationLanguage: navigator.language,
    localizationUsed: 0,

    customerId,
    leaseId,

    merchantName,
    storeId,
    parentStoreId,

    flowName: 'connect',
    flowType: 'connect',
    dataSet: 'connect',

    inStoreFlag: 0,
    textToApplyEnabled: 0,
    bankLookupEnabled: 0,
    localizationEnabled: 0,
    paymentEstEnabled: 0,
    rldEnabled: 0,
    storeLocatorEnabled: 0,
  });
};

export const gtmApplicationStart = ({ reapply }: { reapply: boolean }) => {
  window.pcDataLayer.push({
    eventCategory: 'Lease Application',
    eventAction: 'Start Application Success',
    eventLabel: 'Start Success',
    applicationStarted: 'true',
    applicationsStarted: '1',
    applicationReapply: reapply ? '1' : '0',
    ...defaultData,
  });
};

export const gtmCheckoutComplete = () => {
  window.pcDataLayer.push({
    event: 'eventTracker',
    eventCategory: 'Checkout',
    eventAction: 'Checkout Complete',
    eventLabel: 'Complete No Fail',
    eventValue: 0,
    eventNonInteraction: 0,
    checkoutsCompleted: 1,
    checkoutCompletionTime: '1',
  });
};

export const gtmApplicationSubmit = () => {
  window.pcDataLayer.push({
    eventCategory: 'Lease Application',
    eventAction: 'Submit Application',
    eventLabel: 'Submit Success',
    ...defaultData,
  });
};

export const gtmApplicationResult = ({ approvalStatus, leaseApprovalAmount, leaseId, customerId }: ApplicationResult) => {
  window.pcDataLayer.push({
    eventCategory: 'Lease Application',
    eventAction: 'Submit Application',
    eventLabel: approvalStatus,
    approvalStatus,
    applicationSubmitted: 'true',
    applicationsSubmitted: '1',
    applicationCompletionTime: '1',
    leaseApprovalAmount,
    leaseId,
    customerId,
    ...defaultData,
  });
};

export const gtmCartSuccess = ({ cartTotal, cartTotalItems, cartTotalQuantity, cashPrice, deliveryCost }: CartSuccess) => {
  window.pcDataLayer.push({
    event: 'eventTracker',
    eventCategory: 'Connect Shopping Cart',
    eventAction: 'Cart Success',
    eventLabel: 'Success',
    eventValue: cashPrice,
    eventNonInteraction: 0,
    cartResult: 'Success',
    cartTotalQuantity,
    cartTotalItems,
    cartTotal,
    cartDeliveryAmount: deliveryCost,
    cartsSubmitted: '1',
    eventType: 'event',
  });
};

export const gtmErrorMessageShown = (errorFlag: string) => {
  window.pcDataLayer.push({
    event: 'eventTracker',
    eventCategory: 'Errors',
    eventAction: 'Connect User Shown Error',
    eventLabel: errorFlag,
  });
};

export const gtmErrorGeneric = (errorType: string, errorMessage: string) => {
  window.pcDataLayer.push({
    event: 'eventTracker',
    eventCategory: 'Errors',
    eventAction: errorType,
    eventLabel: errorMessage,
    hitType: 'event',
  });
};
